import { createVNode as a, mergeProps as n } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NoDataTwoTone.js";
import s from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return a(s, n(e, {
    icon: m
  }), null);
};
o.displayName = "NoDataTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
